import api from "../utils/api";
import { API_CONFIG } from "../utils/apiConfig";

export const getCart = async (storeId) => {
  try {
    const response = await api.get(API_CONFIG.CART.GET_CART, {
      params: storeId ? { store_id: storeId } : undefined
    });
    return response.data;
  } catch (error) {
    console.error("Get cart error:", error);
    return { status: "error", error: error.response?.data?.error || "Failed to fetch cart" };
  }
};

export const addToCartApi = async ({ product_id, quantity = 1, variations, finalPrice, agreed_price, negotiation_session_id }, storeId) => {
  try {
    const response = await api.post(API_CONFIG.CART.ADD_TO_CART, {
      product_id,
      quantity,
      variations,
      finalPrice,
      agreed_price,
      negotiation_session_id,
      ...(storeId ? { store_id: storeId } : {})
    });
    return response.data;
  } catch (error) {
    console.error("Add to cart error:", error);
    return { status: "error", error: error.response?.data?.error || "Failed to add to cart" };
  }
};

export const updateCartItem = async (product_id, quantity, storeId) => {
  try {
    const response = await api.put(API_CONFIG.CART.UPDATE_CART, {
      product_id,
      quantity,
      ...(storeId ? { store_id: storeId } : {})
    });
    return response.data;
  } catch (error) {
    console.error("Update cart error:", error);
    return { status: "error", error: error.response?.data?.error || "Failed to update cart" };
  }
};

export const removeCartItem = async (product_id, storeId) => {
  try {
    const response = await api.post(API_CONFIG.CART.REMOVE_FROM_CART, {
      product_id,
      ...(storeId ? { store_id: storeId } : {})
    });
    return response.data;
  } catch (error) {
    console.error("Remove cart error:", error);
    return { status: "error", error: error.response?.data?.error || "Failed to remove from cart" };
  }
};

export const clearCartApi = async (storeId) => {
  try {
    const response = await api.post(API_CONFIG.CART.CLEAR_CART, {
      ...(storeId ? { store_id: storeId } : {})
    });
    return response.data;
  } catch (error) {
    console.error("Clear cart error:", error);
    return { status: "error", error: error.response?.data?.error || "Failed to clear cart" };
  }
};

export const syncCart = async (items, storeId) => {
  try {
    const response = await api.post(API_CONFIG.CART.SYNC_CART, {
      items,
      ...(storeId ? { store_id: storeId } : {})
    });
    return response.data;
  } catch (error) {
    console.error("Sync cart error:", error);
    return { status: "error", error: error.response?.data?.error || "Failed to sync cart" };
  }
};
